import React from "react";

interface FiltersIconProps {
  color: string;
}

const FiltersIcon = (props: FiltersIconProps) => {
  const { color } = props;
  return (
    <svg width="17" height="17" viewBox="5 5 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_324_23598)">
        <path
          d="M15.67 23.5C20.0883 23.5 23.67 19.9183 23.67 15.5C23.67 11.0817 20.0883 7.5 15.67 7.5C11.2517 7.5 7.66998 11.0817 7.66998 15.5C7.66998 19.9183 11.2517 23.5 15.67 23.5Z"
          fill="#002035"
        />
      </g>
      <path
        d="M12.0034 15.2333C13.0638 15.2333 13.9234 14.3976 13.9234 13.3667C13.9234 12.3357 13.0638 11.5 12.0034 11.5C10.943 11.5 10.0834 12.3357 10.0834 13.3667C10.0834 14.3976 10.943 15.2333 12.0034 15.2333Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.66998 13.3676H10.0834"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9234 13.3676H23.67"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.3365 20.46C20.3969 20.46 21.2565 19.6243 21.2565 18.5934C21.2565 17.5624 20.3969 16.7267 19.3365 16.7267C18.2762 16.7267 17.4165 17.5624 17.4165 18.5934C17.4165 19.6243 18.2762 20.46 19.3365 20.46Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.67 18.5942H21.2565"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4165 18.5942H7.66998"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="filter0_d_324_23598"
          x="0.669983"
          y="0.5"
          width="36"
          height="36"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3" dy="3" />
          <feGaussianBlur stdDeviation="5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.701961 0 0 0 0 0.486275 0 0 0 0 0.509804 0 0 0 0.2 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_324_23598" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_324_23598"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default FiltersIcon;
